import ConfirmDeleteModalUI from '@/components/common/ConfirmDeleteModalUI/ConfirmDeleteModalUI'
import { useConfigUI } from '@/features/config/context'
import useDeleteFertigation from '@/features/config/hooks/fertigation/useDeleteFertigation'
import { debounce } from 'lodash'
import useTranslation from '@/hooks/useTranslation'

interface DeleteModalProps {
  id?: string
  interfaceId?: string
}

const DeleteFertigationModal = ({ id, interfaceId }: DeleteModalProps) => {
  const { t } = useTranslation()
  const { closeModal } = useConfigUI()
  const { mutate: deleteFertigation, isLoading: loadingDelete } =
    useDeleteFertigation()

  const handleDeleteFertigation = debounce(async () => {
    if (!id) return
    if (!interfaceId) return
    deleteFertigation({ interfaceId, id })
  }, 300)

  return (
    <ConfirmDeleteModalUI
      title={t('dataConfigDeleteFertigation?')}
      text={t('fertigationDeleteConfirmation')}
      onClose={closeModal}
      onConfirm={handleDeleteFertigation}
      isLoading={loadingDelete}
    />
  )
}

export default DeleteFertigationModal
